import { createAction } from '../../../../store.model';
import { ChatMessage } from '../../../../teams-call';
import { ActionType } from '../teamschat-dialog.action';

export interface DeleteMessages {
    messages: ChatMessage[];
}

export const deleteMessages = createAction<ActionType, DeleteMessages>(
    ActionType.COACHING_DETAIL__TCD__DELETE_MESSAGES,
);

export interface DeleteMessagesResult extends DeleteMessages {}

export const deleteMessagesResult = createAction<
    ActionType,
    DeleteMessagesResult
>(ActionType.COACHING_DETAIL__TCD__DELETE_MESSAGES_RESULT);
